import { Params } from '@angular/router';
import { ObjectUtils } from '../utils/ObjectUtils';

export class SearchCriteria {
  public page?: number;
  public pageSize?: number;
  public searchText?: string;
  public filters?: string;
  public startDate?: string;
  public endDate?: string;
  public sort?: string;
  public refresh?: boolean;
  private defaultSort?: string;

  constructor(pageSize = 10, defaultSort: string = null) {
    this.page = 1;
    this.pageSize = pageSize;
    this.defaultSort = defaultSort;
  }

  static new(criteria: SearchCriteria, queryParams?: Params, period?: number, sorting?: string): SearchCriteria {
    const searchCriteria = new SearchCriteria();
    searchCriteria.page = 1;
    searchCriteria.pageSize = criteria.pageSize;
    searchCriteria.defaultSort = criteria.defaultSort || null;
    searchCriteria.searchText = queryParams?.searchText || null;
    searchCriteria.filters = this.getFilters(queryParams, period) || null;
    searchCriteria.startDate = queryParams?.startDate || null;
    searchCriteria.endDate = queryParams?.endDate || null;
    searchCriteria.sort = sorting || criteria.defaultSort || null;
    searchCriteria.refresh = queryParams?.refresh || null;
    return searchCriteria;
  }

  private static getFilters(queryParams?: Params, period?: number): string {
    const filters = [queryParams?.filters || '', this.getPeriod(period)];
    return filters.filter(filter => !!filter).join(',');
  }

  private static getPeriod(period: number): string {
    if (!period) {
      return '';
    }

    const now = new Date();
    const periodStart = new Date(now.setDate(now.getDate() - period));
    periodStart.setUTCHours(0);
    periodStart.setMinutes(0);
    periodStart.setSeconds(0);
    periodStart.setMilliseconds(0);
    return `lastModifiedDateTime.gt.${periodStart.toISOString()}`;
  }

  static getParams(criteria: SearchCriteria): Params {
    const clone: SearchCriteria = { ...criteria, refresh: null };
    ObjectUtils.removeNullProperties(clone);
    return clone;
  }
}
